import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyLogo } from '../data/mock';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0f172a] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img src={companyLogo} alt="Charter Roofings" className="h-12 md:h-16" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('hero')} className="nav-link">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('services')} className="nav-link">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('projects')} className="nav-link">
              {t.nav.projects}
            </button>
            <button onClick={() => scrollToSection('about')} className="nav-link">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('sponsorship')} className="nav-link">
              {t.nav.sponsorship}
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              {t.nav.contact}
            </button>
          </nav>

          {/* CTA & Language Switcher */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button
              onClick={toggleLanguage}
              variant="secondary"
              className="btn-secondary flex items-center space-x-2"
            >
              <Globe className="w-4 h-4" />
              <span>{language === 'nl' ? 'EN' : 'NL'}</span>
            </Button>
            <Button
              onClick={() => scrollToSection('quote')}
              className="btn-primary"
            >
              {t.nav.getQuote}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-[#60a5fa] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-[#1e40af] pt-4 bg-[#0f172a] rounded-b-lg">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('hero')} className="nav-link text-left">
                {t.nav.home}
              </button>
              <button onClick={() => scrollToSection('services')} className="nav-link text-left">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection('projects')} className="nav-link text-left">
                {t.nav.projects}
              </button>
              <button onClick={() => scrollToSection('about')} className="nav-link text-left">
                {t.nav.about}
              </button>
              <button onClick={() => scrollToSection('sponsorship')} className="nav-link text-left">
                {t.nav.sponsorship}
              </button>
              <button onClick={() => scrollToSection('contact')} className="nav-link text-left">
                {t.nav.contact}
              </button>
              <div className="flex flex-col space-y-3 pt-4">
                <Button
                  onClick={toggleLanguage}
                  variant="secondary"
                  className="btn-secondary flex items-center justify-center space-x-2 w-full"
                >
                  <Globe className="w-4 h-4" />
                  <span>{language === 'nl' ? 'English' : 'Nederlands'}</span>
                </Button>
                <Button
                  onClick={() => scrollToSection('quote')}
                  className="btn-primary w-full"
                >
                  {t.nav.getQuote}
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
